import { useState, useEffect } from 'react'
import * as ProfileApi from '../services/auth/Profile/ProfileApi'

const useUser = () => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const storedUser = localStorage.getItem('user')
    if (storedUser) {
      setUser(JSON.parse(storedUser))
      setLoading(false) // <-- Add this line
    } else {
      const fetchUser = async () => {
        try {
          const response = await ProfileApi.getProfile()
          const userData = response.data
          localStorage.setItem('user', JSON.stringify(userData))
          setUser(userData)
        } catch (err) {
          setError(err)
        } finally {
          setLoading(false)
        }
      }
      fetchUser()
    }
  }, [])

  return {
    user, // full user object
    roleName: user?.role_name || '',
    screens: user?.Screens || [],
    employee: user?.employee || [],
    loading,
    error,
  }
}

export default useUser
